<template>
  <div>
    <div class="page-title">
      <div class="container">
        <ul class="nav">
          <li class="nav-item border-left-0">
            <a class="nav-link" @click="goHome()">
              <img src="~../assets/image/icon/home.png" height="40" />
            </a>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'works.list' }">課程作業</router-link>
          </li>
          <li class="nav-item" v-if="workObj">
            <a class="nav-link">{{ workObj.name }}</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="container mt-3 pt-5 pb-5" :class="{ 'bg-white': true }" style="min-height: 60vh;">
      <template v-if="isEmpty">
        <empty-page title="沒有指派任何課程作業" description="目前沒有老師指派任何課程給您。" />
        <div class="row mt-5 d-flex">
          <button class="btn btn-success btn-block mt-5 mb-5 w-50 mx-auto" @click.stop.prevent="$router.push('/')">我知道了</button>
        </div>
      </template>

      <div class="row" v-else>
        <div class="col-sm-6 offset-sm-3" v-if="!workObj">
          <ul class="list-group">
            <li class="list-group-item d-flex justify-content-between rounded p-0 mb-3"
              v-for="(course, index) in courses.list" :key="index + course.id">
              <div class="text-left p-1 pl-3 mr-auto">
                課程內容：<span style="font-weight: bold;">{{ course.name }}</span><br>
                指派時間：{{ course.createTime }}<br>
                指派班級：{{ course.groupName }}<br>
                指派老師：{{ course.teacherName }}<br>
                課程數量：{{ course.lessonCount }}
              </div>
              <div class="d-flex align-items-center pr-3">
                <img src="~../assets/image/icon/check_on.png" v-if="course.isDone">
                <img src="~../assets/image/icon/check_off.png" v-else>
              </div>
              <div class="d-flex align-items-center rounded list-group-item-playbtn" style="background-color: #5dceb0;">
                <span class="w-100 text-center"
                  @click="openWork(course)">
                  <img src="~../assets/image/icon/video_play.png">
                </span>
              </div>
            </li>
          </ul>

          <pagination class="mt-3" :current="courses.pageIndex" :total="courses.pageCount" v-on:page="updatePage" />
        </div>

        <div class="col-sm-12" v-else>
          <ul class="nav nav-tabs mb-3">
            <li class="nav-item ml-5">
              <a class="nav-link rounded-top" :class="{ 'active': tab === 'lesson' }" @click="tab = 'lesson'">課程列表</a>
            </li>
            <li class="nav-item ml-3">
              <a class="nav-link rounded-top" :class="{ 'active': tab === 'attachment' }" @click="tab = 'attachment'">附件檔案</a>
            </li>
          </ul>

          <div class="ml-5 mr-5" v-if="tab === 'lesson'">
            <ul class="list-group">
              <li class="list-group-item d-flex justify-content-between mb-3 border-top-0 border-left-0 border-right-0"
                v-for="(course, index) in courseLessons.list" :key="course.id">
                <div class="d-flex align-items-center mr-auto">
                  <b>{{ index < 9  ? '0' + (index + 1) : (index + 1) }}. {{ course.localName }}</b> {{ course.name }}
                </div>
                <div class="d-flex align-items-center mr-3">
                  <img src="~../assets/image/icon/check_off.png">
                </div>
                <div class="d-flex align-items-center mr-3">
                  <icon-button name="more_info" alt="開始課程" @click.native="$router.push({ name: 'lesson.player', params: { lessonId: course.id } })" />
                </div>
              </li>
            </ul>

            <pagination class="col-sm-12 mt-3" :current="courseLessons.pageIndex" :total="courseLessons.pageCount" v-on:page="updatePage" />
          </div>

          <div class="ml-5 mr-5" v-if="tab === 'attachment'">
            <ul class="list-group">
              <li class="list-group-item d-flex justify-content-between mb-3 border-top-0 border-left-0 border-right-0"
                v-for="(item, index) in courseLessons.attachment.list" :key="item.id">
                <div class="d-flex align-items-center mr-3 text-left">
                  {{ item.name }}<br>
                  {{ Math.round(item.fileSize * 1000 / 1024 / 1024) / 1000  }} MB
                </div>
                <div class="d-flex align-items-center mr-3">
                  <icon-button name="student_download" alt="下載" @click.native="getAttachment(item.id)" />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Pagination from '../components/Pagination'
import EmptyPage from './Teacher/EmptyPage'
import IconButton from './Teacher/IconButton'

export default {

  name: 'Works',

  components: {
    Pagination,
    EmptyPage,
    IconButton
  },

  data () {
    return {
      workObj: null,
      tab: 'lesson'
    }
  },

  computed: {
    ...mapGetters([
      'courses',
      'courseLessons'
    ]),

    isEmpty () {
      return this.courses.list.length === 0
    }
  },

  created () {
    this.getCourses()
    let workId = this.$route.params.workId
    if (workId) {
      this.getCourseLessons(workId)
      this.workObj = { name: '作業' }
    }

    this.$watch('$route.params.workId', (val, oldVal) => {
      if (val) {
        this.getCourseLessons(val)
      } else {
        this.workObj = null
      }
    })
  },

  methods: {
    ...mapActions([
      'getCourses',
      'getCourseLessons',
      'getAttachment'
    ]),

    updatePage (page) {
      !this.workObj ? this.getCourses({
        'pageIndex': page
      }) : this.getCourseLessons({
        'pageIndex': page
      })
    },

    openWork (obj) {
      if (!obj) {
        this.workObj = null
        return false
      }

      this.$router.push({ name: 'works.list', params: { workId: obj.id } })
      this.workObj = obj
    }
  }
}
</script>

<style lang="scss" scoped>
  .nav-link {
    color: #000;

    &.active {
      background-color: #c2c2c2!important;
      color: #fff!important;
    }
  }

  .rounded-top {
    border-top-left-radius: 0.75rem!important;
    border-top-right-radius: 0.75rem!important;
  }
</style>



// WEBPACK FOOTER //
// Works.vue?719d0e5d